export default "/images/vendor/flag-icon-css/flags/1x1/uz.svg?ba79d2974850ade2d0360e7cd0616f31";